export default "__VITE_PUBLIC_ASSET__d2f191e9__"